"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSplittedFilename = exports.extensionsMap = exports.EExtensionType = void 0;
var EExtensionType;
(function (EExtensionType) {
    EExtensionType["pdf"] = "pdf";
    EExtensionType["xls"] = "xls";
    EExtensionType["xlsx"] = "xlsx";
    EExtensionType["doc"] = "doc";
    EExtensionType["docx"] = "docx";
    EExtensionType["png"] = "png";
    EExtensionType["jpg"] = "jpg";
    EExtensionType["jpeg"] = "jpeg";
})(EExtensionType = exports.EExtensionType || (exports.EExtensionType = {}));
exports.extensionsMap = new Map([
    [EExtensionType.pdf, "application/pdf"],
    [EExtensionType.xls, "application/excel"],
    [EExtensionType.xlsx, "application/excel"],
    [EExtensionType.doc, "application/msword"],
    [EExtensionType.docx, "application/msword"],
    [EExtensionType.png, "image/png"],
    [EExtensionType.jpg, "image/jpeg"],
    [EExtensionType.jpeg, "image/jpeg"],
]);
function getSplittedFilename(filename) {
    const splitName = filename.split(".");
    const fileNameWithoutExtension = splitName.slice(0, -1).join(".");
    const fileExtension = splitName[splitName.length - 1];
    return [fileNameWithoutExtension, fileExtension];
}
exports.getSplittedFilename = getSplittedFilename;
//# sourceMappingURL=attachments.js.map